import type { FandomLegacyContext } from "common-types";

/**
 * Retrieves the ads context from the global `window` object.
 * The function accesses the `window.ads.context` property, which is expected to hold
 * the ads-related context information.
 *
 * @returns The ads context if available, or `null` if not present.
 */
export function getAdsContext(): FandomLegacyContext | null {
  return window.ads?.context ?? null;
}
